module.exports = __webpack_public_path__ + "static/media/NovotelSipcot02.dc351b34.jpg";